import {OrderService, MovieService, RegionService, AuthService} from 'hasta-la-vista-middleware-api/service'
export default {
    data() {
        return {
            loading: true,
            cancelAlert: false,
            items: [],
            order: null,
            user: null,
            guest: true,
            subsClub: undefined
        }
    },

    methods: {
        setUser(){
            AuthService.user().then((user)=> {
                this.user = user;
                this.guest = user.isGuest();
                if (this.guest) window.location.href = '/user/login'
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club')
        },

        continueToNextStep() {
            let lsItem = {
                'item': this.subsClub.item,
                'progress': {'current-step': 1, 'current-step-name': "subscription-summary", "current-step-url": "/subscribe/1", 'next-step': 2, "next-step-name": "confirm-details", "next-step-url": "/subscribe/2"}
            }

            window.localStorage.setItem('subsClub', JSON.stringify(lsItem));
            this.$router.push('/subscribe/2')
        }
    },

    created() {
        this.loading = true
        Promise.all([this.setUser(), this.getSubsData()]).then(
            ([user, subs]) => {
                this.loading = false

                // console.log(this.subsClub)
            }, 
            (error) => {
                Promise.reject(error)
            }
        );
    },

    mounted(){
        window.scrollTo(0, 0)
        window.scroll({top: 0, left: 0})
    },
}


// WEBPACK FOOTER //
// ./src/components/subs-club/subscription-summary/subscription-summary.js